import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { BearerTokenKeyName } from "../constants/strings";
import { AuthenticationService } from "../services/authentication/authentication.service";
import { LocalStoreManager } from "../services/local-store-manager/local-store-manager.service";
import { SessionIdService } from "../services/session-id/session-id.service";

@Injectable()
export class BearerTokenInterceptor implements HttpInterceptor {
    constructor(private readonly localStoreManager: LocalStoreManager,
        private readonly authenticationService: AuthenticationService,
        private readonly sessionIdService: SessionIdService) { }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const bearerToken = this.localStoreManager.getData(BearerTokenKeyName);
        const windowsAuthRequest = this.authenticationService.getIsWindowsAuthRequest();
        const anonymousRequest = this.authenticationService.getIsAnonymousRequest();

        req = req.clone({
            ...(windowsAuthRequest && { withCredentials: true }),
            setHeaders: {
                ...(bearerToken && !windowsAuthRequest && !anonymousRequest && { 'OneTwoThreeAuth': bearerToken }),
                'Cache-Control': 'no-cache, no-store, must-revalidate',
                'Pragma': 'no-cache',
                'OneTwoThreeSessionId': this.sessionIdService.getSessionId(),
                'X-Correlation-Id': crypto.randomUUID().replace(/-/g, '')
            }
        });

        return next.handle(req);
    }
}
